


export default function IncomeFormComponent({ formData, handleInputChange ,errors}) {
    const handleChange = (e) => {
        handleInputChange(e); // Call the parent function which already handles validation
    };

    return (
        <div>
            <h4>Income Information</h4>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "left", gap: "20px", marginTop: "20px" }}>
                {/* Monthly Income Field */}
                <div className="single-box">
                    <div className="inner-title">
                        <p>Monthly Income</p>
                    </div>
                    <input
                        type="text"
                        name="Monthly_income"
                        value={formData.Monthly_income || ""}
                        onChange={handleChange}
                        style={{ width: "400px" }}
                        required
                    />
                    <span style={{ color: "red", fontSize: "12px", marginTop: "-10px", display: "block" }}>{errors.Monthly_income}</span>
                </div>

                {/* Source of Income Field */}
                <div className="single-box">
                    <div className="inner-title">
                        <p>Source of Income</p>
                    </div>
                    <input
                        type="text"
                        name="Source_of_income"
                        value={formData.Source_of_income || ""}
                        onChange={handleChange}
                        style={{ width: "400px" }}
                        maxLength={50 }
                        required
                    />
                    <span style={{ color: "red", fontSize: "12px", marginTop: "-10px", display: "block" }}>{errors.Source_of_income}</span>
                </div>
            </div>
        </div>
    );
}
